import React, { useState } from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Col, Row, Form, Input, Tooltip, Select, Checkbox, Button } from "antd";

const name = "options"


const QUESTION_TYPES = [
    {
        name: "Preguntas abiertas",
        value: "text"
    },
    {
        name: "Preguntas de selección",
        value: "list"
    }
]

const QuestionFields = ({ remove, id, form, initialValues={ 
  id: null,
  input_type : null,  
  is_video: false,
  question: "",
  required: false,  
  selection_process_options: []
} }) => {

  const { getFieldDecorator } = form
  const questions = initialValues.selection_process_options
  const [ size, setSize ] = useState(initialValues.selection_process_options.length)
  const [ type, setType ] = useState(initialValues?.input_type==="list" ? "list" : "text")
  const fields = form.getFieldValue(`${name}${id}`) || [...Array(initialValues.selection_process_options.length).keys()]

  form.getFieldDecorator(`${name}${id}` , { initialValue: [...Array(questions.length).keys()] })
  form.getFieldDecorator(`question_id[${id}]` , { initialValue: initialValues.id })

  const innerAdd = () => {
    const keys = form.getFieldValue(`${name}${id}`);
    const nextKeys = keys.concat(size);
    setSize(size+1)
    form.setFieldsValue({
    [`${name}${id}`]: nextKeys,
    });
  }

  const innerRemove = (k) => {
      const keys = form.getFieldValue(`${name}${id}`);
      form.setFieldsValue({
      [`${name}${id}`]: keys.filter(key => key !== k),
      });
  }

  return (
    <>
      <Row>
        <Col xs={{ span: 22 }}>
          <Form.Item
            label={`Pregunta`}
          >
            {getFieldDecorator(`question[${id}]`, {
              initialValue: initialValues?.question,    
              rules: [
                {
                  required: true, message: "El campo es requerido."
                }, 
                {
                  min: 2,
                  message: "El campo debe tener minimo 2 caracteres"}
                ] 
            })( 
              <Input size="large" />
            )}
          </Form.Item>
        </Col>
        <Col style={{ top: 60 }} xs={{ offset: 1,span: 1 }}>
            <Tooltip title="Quitar pregunta">
                <Button className="delete-button" icon="delete" onClick={() => remove(id, initialValues.id)} />
            </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 8 }}>
          <Form.Item
          >
            {getFieldDecorator(`input_type[${id}]`, {initialValue: type})(
                <Select
                style={{ width: "100%" }}
                optionLabelProp="label"
                placeholder="Tipo de pregunta"
                onChange={(value)=> setType(value)}
                >
                {QUESTION_TYPES.map((item) => (
                    <Select.Option key={item.value} value={item.value} label={`${item.name}` || ""}>{item.name}</Select.Option>
                ))}
                </Select>
            )}
          </Form.Item>
        </Col>

        <Col xs={{ span: 6, offset: 2 }}>
            <Form.Item>
                {getFieldDecorator(`question_required[${id}]`, {
                initialValue: initialValues?.required, 
                })( 
                    <Checkbox defaultChecked={initialValues?.required} > Mostrar como obligatoria </Checkbox>
                )}
            </Form.Item>
        </Col>
        { type === "text" &&
          <Col xs={{ span: 6 }}>
              <Form.Item>
                  {getFieldDecorator(`question_is_video[${id}]`, {
                  initialValue: initialValues?.is_video
                  })( 
                      <Checkbox defaultChecked={initialValues?.is_video}> Mostrar como video </Checkbox>
                  )}
              </Form.Item>
          </Col>
        }
    </Row>
    {type === "list" && 
    <>
      {fields.map((value, index) => (
          <div key={value}>
            <Row>
              <Col xs={{span: 12}}>
              <Form.Item
                  label={`Opción`}
                  style={{display: "none"}}
                >
                  {getFieldDecorator(`option_id${id}[${index}]`, {
                    initialValue: questions[value]?.id,
                  })( 
                    <Input size="large" />
                  )}
                </Form.Item>
              <Form.Item
                  label={`Opción`}
                >
                  {getFieldDecorator(`option${id}[${index}]`, {
                    initialValue: questions[value]?.value,
                    rules: [{required: true, message: "El campo es requerido."}] 
                  })( 
                    <Input size="large" />
                  )}
                </Form.Item>
              </Col>
              <Col style={{ top: 60 }} xs={{ offset: 1,span: 1 }}>
                <Tooltip title="Quitar opción">
                  <Button className="delete-button" icon="delete" onClick={() => innerRemove(value, questions[index]?.id)} />
                </Tooltip>
              </Col>
            </Row>
          </div>
      ))}
      <Form.Item>
          <Button className="custom-button-postulation" onClick={()=>innerAdd()}>
          + Agregar nueva opción
          </Button>
      </Form.Item>
      </>
      }
    </>
  );
};

export default QuestionFields;
